import { createApp } from 'vue'
import BuySection from './BuySection'

const el = '.kb-component--buy-section'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    
    if (DOM && DOM.length) {
        DOM.forEach((BuySectionDOM) => {
            const props = {
                variants: BuySectionDOM.dataset.variants??'',
                currentVariantSku: BuySectionDOM.dataset.currentVariantSku,
                productCode: BuySectionDOM.dataset.productCode,
                pdf: BuySectionDOM.dataset.pdf??'',
                soldOutText: BuySectionDOM.dataset.soldOutText??'',
                basketPageUrl: BuySectionDOM.dataset.basketPageUrl??'',
                hasRequiredRights: BuySectionDOM.dataset.hasRequiredRights,
                rolePageUrl: BuySectionDOM.dataset.rolePageUrl ?? '',
                openRecommendationOverlay: BuySectionDOM.dataset.openRecommendationOverlay === 'true' ? true : false,
            }
            const component = createApp(BuySection, props).use(Store)
            component.mount(BuySectionDOM)
        })
    }
}
